import { AbstractService } from 'services/AbstractService'
import { ServiceError } from 'services/errors'
import config from 'config'
import getLogger from 'shared/logger'

export interface RatingsReviewsResponse {
  reviewsCount: number
  ratedXOutOfYLabel: string
  averageRating: number
  reviewsCountLabel: string
  reviewedByNCustomersLabel: string
  stars: number[]
}

export class RatingsAndReviewsApi extends AbstractService {
  public async getRatingsAndReviews(locale: i18n.Locale, mpvId: string): Promise<RatingsReviewsResponse> {
    const url = `v1/reviews-summary/${config.tenant}/${locale}/${mpvId}`

    try {
      const response = await this.api.get<RatingsReviewsResponse>(url)
      return response.data
    } catch (e) {
      throw new ServiceError(
        {
          url,
          message: `Bad response from ratings and reviews service: ${(e as Error).message}`,
        },
        e as Error,
      )
    }
  }
}

export const RatingsAndReviewsService = new RatingsAndReviewsApi(config.services.ratingsAndReviewsService, getLogger)
